import { useTheme } from "@/hooks/useTheme";

// Clean segmented Light | Dark toggle used site-wide.
export default function ThemeSwitch({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const opts = ["light", "dark"];
  return (
    <div
      role="group"
      aria-label="Theme"
      data-testid="theme-switch"
      className={`inline-flex items-center rounded-full border border-ivory/15 p-0.5 ${className}`}
    >
      {opts.map((t) => {
        const active = theme === t;
        return (
          <button
            key={t}
            type="button"
            onClick={() => setTheme(t)}
            aria-pressed={active}
            data-testid={`theme-${t}`}
            className={`rounded-full px-3 py-1.5 font-sans text-[10px] uppercase tracking-widest transition-colors ${
              active ? "bg-gold text-ink-950" : "text-ivory-muted hover:text-ivory"
            }`}
          >
            {t}
          </button>
        );
      })}
    </div>
  );
}
